import { render, staticRenderFns } from "./dashboard-employee.vue?vue&type=template&id=dc689aec&scoped=true"
import script from "./dashboard-employee.vue?vue&type=script&lang=js"
export * from "./dashboard-employee.vue?vue&type=script&lang=js"
import style0 from "./dashboard-employee.vue?vue&type=style&index=0&id=dc689aec&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc689aec",
  null
  
)

export default component.exports